export default "__VITE_ASSET__9g1XmQG7__"